<sc-flex vertical stretchContent fitHeight>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.priority"
      [value]="movementOrderDetails?.priority ? 'Ja' : 'Nein'"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.referenceDate"
      [value]="movementOrderDetails?.referenceDate | date:'dd.MM.yy H:mm'"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.scope"
      [value]="movementOrderDetails?.scope"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.identifier"
      [value]="movementOrderDetails?.identifier"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.currentStation"
      [value]="movementOrderDetails?.currentStation"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.targetStation"
      [value]="movementOrderDetails?.targetStation"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.transportReference"
      [value]="movementOrderDetails?.transportReference"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field
        labelDictionaryKey="tmc-yard.entity.moving-order.processingStatus.label"
        [value]="movementOrderDetails?.processingStatus ? (movementOrderDetails?.processingStatus | translate:['tmc-yard.entity.moving-order.processingStatus.' + movementOrderDetails?.processingStatus,
                  translationService.language, translationService.revision]) : ''"></sc-read-only-field>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
  @if (responseMessages.length>0) {
    <sc-content-spacer vertical></sc-content-spacer>
  }
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex>
      <sc-cancel-action-button (click)="cancel()" [disabled]="!cancelEnabled || loading">
      </sc-cancel-action-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-back-button (click)="handleStatusChangeReverse()"
        [disabled]="!statusChangeReverseButtonEnabled || loading">
      </sc-back-button>
      <sc-content-spacer></sc-content-spacer>
      @if (statusChangeButtonVisible) {
        <sc-button primary (click)="handleStatusChange()" [disabled]="!statusChangeButtonEnabled || loading"
          [dictionaryKey]="statusChangeLabel">
        </sc-button>
      }
    </sc-flex>
  </div>
</sc-flex>
